import * as Yup from 'yup';

export const createClientAssessmentSchema = Yup.object().shape({
  client_id: Yup.number().required().min(0),
  date_start: Yup.string().required(),
  duration: Yup.number().required(),
  location: Yup.string().required(),
  delivery_method: Yup.string().required(),
  utc_offset_date_start: Yup.number().required(),
});

export const assessmentFormSchema = Yup.object().shape({
  activity_conducted: Yup.object()
    .shape({
      is_assessment_administered: Yup.boolean(),
      is_findings_of_assessment_discussed: Yup.boolean(),
      is_recommendations_based_on_assessment_discussed: Yup.boolean(),
      is_past_data_analyzed_non_face_to_face: Yup.boolean(),
      is_assessment_scored_or_interpreted: Yup.boolean(),
      is_report_or_treatment_plan_prepared: Yup.boolean(),
    })
    .test((values) => {
      return Object.values(values).some((value) => value === true);
    }),
  notes: Yup.string().trim().min(120).required(),
});
